import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/spooky-island-cover.webp";
import CrazyIFrame from 'src/components/CrazyIFrame';


export const projectDetails: ProjectInterface = {
    url: "spooky-island",
    title: "Spooky Island",
    summary: "Defeat island monsters and expand your base.",
    description: `In Spooky Island, I focused on porting the game to the web while simultaneously enhancing gameplay and optimizing player experience in the web. I collaborated with the art team to adjust the UI for web compatibility and developed specialized tools for the porting process. Additionally, I integrated essential SDKs and external tools to enhance the game's functionality on the web platform.`,
    year: "2022",
    tags: ["Casual", "Adventure", "WebGL", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.PROFESSIONAL,
    roles: ["Programmer"],
    studio: ["Izyplay Game Studio"],
    technologies: ["Unity", "C#", "WebGL"],
    platforms: ["Web"],
    collaborators: ["[link=Izyplay Game Studio|https://izyplay.com.br/]"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData:
        [
            { type: 'text', url: "https://www.crazygames.com/game/spooky-island" },
        ],
    relatedProjects: ["IzasSupermarket", "ShepherdFarm", "CheckMore"],
};


export function SpookyIsland() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <CrazyIFrame src="https://www.crazygames.com/embed/spooky-island" height={500} title="Spooky Island" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}